{
  "en": {
    "milestone_unit": {
      "actions": {
        "change_milestone": "Change milestone",
        "reset_columns": "Reset columns"
      },
      "labels": {
        "columns": "Columns",
        "milestone": "Please select a new milestone",
        "no_results": "No units found"
      }
    }
  }
}
